import React, { useState, useEffect } from "react";
import Background from '../img/Wallpaper.png';
import Logo from '../img/AlyonaLogo.png';
import BGHeader from '../img/BGHeader.png';
import MenuIcon from '../img/menu_icon.png';
import ConcertsIcon from '../img/concerts_icon.png';
import VideoIcon from '../img/video_icon.png';
import MerchIcon from '../img/merch_icon.png';
import ContactsIcon from '../img/contacts_icon.png';
export const Header = ({ transparent = false, fixed = true, page = "" }) => {
  const [isMenuOpen, setMenuOpen] = useState(false);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 1024) {
        setMenuOpen(false);
      }
    };
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);
  return (
    <header
      className={`${transparent && 'absolute'} bg-transparent py-5 lg:py-6 ${fixed === false ? '' : 'lg:fixed'} top-0 left-0 w-full z-50`}
      style={
        !transparent
          ? {
            backgroundImage: `url(${Background})`,
            backgroundSize: 'cover',
            backgroundPosition: 'center',
          }
          : undefined
      }
    >
      <div className="hidden lg:flex justify-center">
        <div className="xl:max-w-[1124px] w-full">
          <div className="flex items-center justify-center space-x-16">
            <a className="cursor-pointer" href="/">
              <img src={Logo} alt="logo" width="60" height="20" />
            </a>
            <div className="hidden lg:flex lg:flex-row items-center space-x-8 xl:space-x-8">
              <a className="flex flex-row items-center space-x-4 cursor-pointer group" href="/">
                <img
                  alt="menu"
                  src={MenuIcon}
                  width="20"
                  height="20"
                  className="group-hover:rotate-[-12deg]"
                />
                <p className={`font-babayka font-normal text-white text-[27px] group-hover:underline ${page === 'main' && 'underline'}`}>
                  Главная
                </p>
              </a>
              <a className="flex flex-row items-center space-x-4 cursor-pointer group" href="/concerts">
                <img
                  alt="concerts"
                  src={ConcertsIcon}
                  width="20"
                  height="20"
                  className="group-hover:rotate-[12deg]"
                />
                <p className={`font-babayka font-normal text-white text-[27px] group-hover:underline ${page === 'concerts' && 'underline'}`}>
                  Концерты
                </p>
              </a>
              <a className="flex flex-row items-center space-x-4 cursor-pointer group" href="/videos">
                <img
                  alt="video"
                  src={VideoIcon}
                  width="20"
                  height="20"
                  className="group-hover:rotate-[-12deg]"
                />
                <p className={`font-babayka font-normal text-white text-[27px] group-hover:underline ${page === 'videos' && 'underline'}`}>
                  Видео
                </p>
              </a>
              <a className="flex flex-row items-center space-x-4 cursor-pointer group" href="/merch">
                <img
                  alt="merch"
                  src={MerchIcon}
                  width="20"
                  height="20"
                  className="group-hover:rotate-[12deg]"
                />
                <p className={`font-babayka font-normal text-white text-[27px] group-hover:underline ${page === 'merch' && 'underline'}`}>
                  Мерч
                </p>
              </a>
              <a className="flex flex-row items-center space-x-4 cursor-pointer group" href="/contacts">
                <img
                  alt="contacts"
                  src={ContactsIcon}
                  width="20"
                  height="20"
                  className="group-hover:rotate-[-12deg]"
                />
                <p className={`font-babayka font-normal text-white text-[27px] group-hover:underline ${page === 'contacts' && 'underline'}`}>
                  Контакты
                </p>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div className="lg:hidden flex justify-between items-center px-8 relative">
        {}
        <button
          className="lg:hidden flex items-center absolute left-8"
          onClick={() => setMenuOpen(true)}
        >
          <img src={MenuIcon} alt="Menu" width="20" height="20" />
        </button>
        {}
        <a href="/" className="cursor-pointer mx-auto">
          <img src={Logo} alt="Logo" width="55" height="35" />
        </a>
      </div>
      {}
      <div
        className={`fixed top-0 left-0 h-full bg-gray-900 text-white z-50 transform ${isMenuOpen ? "translate-x-0" : "-translate-x-full"
          } transition-transform duration-300 ease-in-out w-full`}
        style={{
          backgroundImage: `url(${BGHeader})`,
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }}
      >
        <button
          className="absolute top-12 right-12 text-white text-4xl"
          onClick={() => setMenuOpen(false)}
        >
          ✕
        </button>
        <nav className="flex flex-col space-y-6 mt-16 p-12">
          <a href="/" className={`text-3xl font-crooker hover:underline ${page === 'main' && 'underline'}`}>
            Главная
          </a>
          <a href="/concerts" className={`text-3xl font-crooker hover:underline ${page === 'concerts' && 'underline'}`}>
            Концерты
          </a>
          <a href="/videos" className={`text-3xl font-crooker hover:underline ${page === 'videos' && 'underline'}`}>
            Видео
          </a>
          <a href="/merch" className={`text-3xl font-crooker hover:underline ${page === 'merch' && 'underline'}`}>
            Мерч
          </a>
          <a href="/contacts" className={`text-3xl font-crooker hover:underline ${page === 'contacts' && 'underline'}`}>
            Контакты
          </a>
        </nav>
      </div>
    </header>
  );
};